// src/components/Loader.jsx
import React from 'react';
import './Loader.css'; // if using custom CSS

const Loader = () => {
    return (
        <div className="loader-overlay">
            <div className="loader"></div>
        </div>
    );
};

export default Loader;